<template>
  <div class="product-container">
    <div class="j-title title">{{ $t('home.product') }}</div>

    <div class="j-container">
      <div class="product-action-container" v-if="vehicleTypes.length > 0">
        <div
          class="product-action"
          :class="{
            'product-action-first': index === 0,
            'product-action-last': index === vehicleTypes.length - 1,
            'product-action-active': v.id === selectedType
          }"
          v-for="(v, index) in vehicleTypes"
          :key="v.id"
          @click="handleTypeChange(v.id)"
        >
          {{ $t(v.vehicleType) }}
        </div>
      </div>
      <div
        v-if="loaded && vehicleTypes.length === 0"
        class="j-coming-soon j-content"
      >
        {{ $t('common.coming_soon') }}
      </div>
    </div>

    <div v-if="vehicleTypes.length > 0">
      <a-row :gutter="[1, 1]" v-if="products.length > 0">
        <a-col :xs="24" :sm="24" :md="8" v-for="p in products" :key="p.id">
          <div class="product" @click="gotoProd(p)">
            <div class="product-img">
              <img @load="calculateImg" v-if="getImg(p)" :src="getImg(p)" />
              <div v-else class="no-img">
                {{ $t('common.no_img') }}
              </div>
            </div>
            <div class="product-desc">
              <div
                class="product-name j-might-overflow"
                v-html="!p.modelNum ? '\u00a0' : p.modelNum"
              ></div>
              <a-divider type="vertical" class="product-divider" />
              <div class="product-info j-might-overflow">
                {{ $t(p.vehicleName) }}
              </div>
            </div>
          </div>
        </a-col>
      </a-row>

      <div
        v-if="selfLoaded && products.length === 0"
        class="j-coming-soon j-content"
      >
        {{ $t('common.coming_soon') }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { mapState } from 'vuex';
import { defineComponent } from 'vue';
import { getVehicleListByType } from '@/api/apis';
import { baseFileUrl } from '@/utils/constants';

export default defineComponent({
  name: 'ProductSection',
  props: {
    vehicleTypes: {
      type: Array,
      required: true,
      default: () => []
    },
    loaded: {
      required: true,
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState(['lang'])
  },
  watch: {
    lang() {
      const prods = Array.from(document.querySelectorAll('.product-action'));
      prods.forEach(p => {
        (p as any).style.width = 'auto';
      });
      this.isProdActionWidthSet = false;
    }
  },
  data(): any {
    const selectedType =
      this.vehicleTypes.length > 0 ? (this.vehicleTypes[0] as any).id : 0;
    return {
      selectedType,
      products: [],
      selfLoaded: false,
      isProdActionWidthSet: false
    };
  },
  updated() {
    this.calculateImg();

    // 找到所有item
    if (!this.isProdActionWidthSet) {
      setTimeout(() => {
        const prods = Array.from(document.querySelectorAll('.product-action'));

        const widths = prods.map(p => p.clientWidth);

        // 找到最大的

        const maxWidth = Math.max(...widths);

        prods.forEach(p => {
          (p as any).style.width = `${maxWidth}px`;
        });
      }, 500);
      this.isProdActionWidthSet = true;
    }
  },
  created() {
    this.loadData();

    this.$bus.$on('calculate-img', this.calculateImg);
  },
  methods: {
    calculateImg() {
      const imgs: any[] = Array.from(document.querySelectorAll('.product-img'));

      imgs.forEach(e => {
        if (e.parentElement) {
          e.style.height = `${(e.parentElement?.offsetWidth * 5) / 8}px`;
        }
      });
    },
    gotoProd(vehicle) {
      this.$router.push(`/products?vehicleType=${vehicle.vehicleType}`);
    },
    getImg(product) {
      const showImgs = (product.showImg || '').split(',').filter(s => s);
      return showImgs.length > 0 ? baseFileUrl + showImgs[0] : '';
    },
    async loadData() {
      if (this.selectedType > 0) {
        const res = await getVehicleListByType({
          type: this.selectedType
        });

        if (res.success) {
          this.products = res.result || [];
        }
      }

      this.selfLoaded = true;
    },
    handleTypeChange(id) {
      if (id !== this.selectedType) {
        this.selectedType = id;
        this.selfLoaded = false;

        this.loadData();
      }
    }
  }
});
</script>

<style lang="scss" scoped>
.title {
  text-align: center;
  margin-bottom: 30px;
}

.product-container {
  padding: 0.5px;

  margin-bottom: 80px;

  .product-action-container {
    margin-bottom: 40px;
    flex-wrap: wrap;
    display: flex;
    justify-content: center;
    align-items: center;

    .product-action {
      color: $primary-secondary-forecolor;
      border: 1px solid $secondary-color2;
      padding: 4px 24px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      white-space: nowrap;
      flex-shrink: 0;
    }

    .product-action-active {
      background: $primary-color;
      color: white;
      border-color: $primary-color;
    }

    .product-action-first {
      border-top-left-radius: 100px;
      border-bottom-left-radius: 100px;
      border-right: none;
    }

    .product-action-last {
      border-top-right-radius: 100px;
      border-bottom-right-radius: 100px;
      border-left: none;
    }
  }

  .product {
    cursor: pointer;
    border-radius: 1px;

    .product-img {
      img {
        display: inline-block;
        width: 100%;
        height: 100%;
      }

      .no-img {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .product-divider {
      margin: 0 30px;
      height: 22px;
      background: #333333;
    }

    .product-desc {
      display: flex;
      align-items: center;
      padding: 22px 60px;
      background: $secondary-color1;

      .product-name {
        font-size: $secondary-fontsize;
        flex: 1;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .product-info {
        font-size: $content-fontsize;
        flex: 1;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }

    &:hover {
      .product-desc {
        color: white;
        background: $primary-color;
      }

      .product-divider {
        background: white;
      }

      transition: all 0.5s;
    }
  }
}
</style>
